<div class="sticker-header sticker-header__header">
  <div
    class="sticker-header__header-content"
    [class.sticker-header--sticker-spacing]="stickerSrc() || stickerContent()"
  >
    @if (affiliateLogo(); as logo) {
      <a
        class="sticker-header-affiliate-logo"
        [class.sticker-header-affiliate-logo--with-sticker]="
          stickerSrc() || stickerContent()
        "
        [href]="logo.url"
        [target]="logo.target"
        [attr.aria-label]="logo.description"
      >
        <img [src]="logo.logo" [alt]="logo.description" />
      </a>
    }
    @if (title()) {
      <h2 class="m-0">{{ title() }}</h2>
    }
    @if (subtitle()) {
      <p class="sticker-header-subtitle m-0">
        {{ subtitle() }}
      </p>
    }
  </div>
  @if (stickerContent()) {
    <div
      wlAutomationId="sticker-content"
      class="sticker-header__wrapper sticker-theme__{{ stickerTheme() }}"
    >
      <p
        [class.sticker-header__content]="stickerContentLineCount() < 4"
        [class.sticker-header__content-sm]="stickerContentLineCount() > 3"
      >
        @for (line of stickerContentByLine(); track $index) {
          @if ($index === stickerFocusLine()) {
            <span class="sticker-header__focus-line">{{ line }}</span
            ><br />
          } @else {
            {{ line }}<br />
          }
        }
      </p>
    </div>
  }
  @if (stickerSrc() && !stickerContent()) {
    <div wlAutomationId="sticker-image" class="sticker-header__sticker">
      <img
        [src]="stickerSrc()"
        [alt]="stickerAlt()"
        class="sticker-header__sticker-img"
      />
    </div>
  }
</div>
